// @core/api/endpoints/booking/list_resources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListResourcesResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List bookable resources
 * Returns bookable resources filtered by type, category, provider, and status.
 */
export async function ListResources(
  params?: {
    booking_type_id?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    q?: string | number | boolean;
    sort?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListResourcesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources`;
  const requestOptions = options;
  return client.get<ListResourcesResponse>(requestPath, { ...requestOptions, params });
}
